<template>
    <div class="d-flex align-items-center justify-content-start gap-3 scroll-parent">
        <div ref="scrollElement" class="scroll-element d-flex align-items-center justify-content-center gx-5 mw-100 gap-5 mh-100" :style="{ animationPlayState: (animate || !stopOnHover) ? 'running' : 'paused'}" @mouseenter="animate = false" @mouseleave="animate = true">
            <slot class="carousel__slide"></slot>
            <slot class="carousel__slide"></slot>
        </div>
    </div>
</template>
<style>
.scroll-parent {
  position:relative;
  width:100vw;
  overflow:hidden;
  overflow-y:auto;
  transform: translate3d(0, 0, 0);
}

@keyframes scroll {
    0% { left: 2.5rem }
	100% { left: calc(-0.5 * var(--element-width)); }  
}

.scroll-element {
    --element-width: 100%;
    position:absolute;
    left: 2.5rem;
    animation: none;
    animation-play-state: running;
}

</style>
<script setup>
const props = defineProps({
    speed: {
        type: Number,
        default: 15
    },
    direction: {
        type: String,
        default: 'left'
    },
    stopOnHover: {
        type: Boolean,
        default: true
    }
})
const scrollElement = ref(null)
const animate = ref(true)
onMounted(() => {
    const width = scrollElement.value?.offsetWidth
    scrollElement.value?.style.setProperty('--element-width', width + "px");
    scrollElement.value.style.animation = `scroll ${props.speed}s linear infinite ${props.direction == 'left' ? 'forwards' : 'reverse'}`
})
</script>